const e=async(e,t)=>{await e.post(`/auth/mfa/preferred`,{method:t})};export{e as setPreferredMfa};
//# sourceMappingURL=set-preferred-mfa.mjs.map